import { MenuItem } from '@chakra-ui/react';
import * as React from 'react';

import { EditIcon } from '@/imports/ui/chakra/feather';

export const EditCommentDropdownItem: React.FC<{
  comment: any;
  onClickEdit: () => void;
}> = ({ comment, onClickEdit }) => {
  return (
    <>
      <MenuItem icon={<EditIcon />} onClick={onClickEdit}>
        Edit
      </MenuItem>
    </>
  );
};
